module.exports = __webpack_public_path__ + "static/img/1.e250741.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R407C/1.jpg
// module id = Q1Q5
// module chunks = 1